import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
} from "@gsa/ui/components/ui/card";
import { Icons } from "@gsa/ui/icons";

import { H3, P } from "../../../ui/typography";

export function PayByCheck() {
  return (
    <Card>
      <CardHeader>
        <Icons.check className="h-12 w-12" />
        <H3> Pay By Check</H3>
        <CardDescription>
          Please mail your check to the address below. We will send you a
          receipt and a copy of your check.
        </CardDescription>
      </CardHeader>

      <CardContent>
        <div className="flex flex-col gap-2">
          <P>Gold Standard Auctions</P>

          <P>13859 Diplomat Dr Suite 150</P>

          <P>Dallas, TX 75234</P>
        </div>
      </CardContent>
    </Card>
  );
}
